import React from "react";
import { useNavigate } from "react-router-dom";
import BookingReportList from "./Admin/BookingReportList";
import DeliveryReportList from "./Admin/DeliveryReportList";
// import LatestCirculars from "../Components/LatestCirculars";
// import FlipCard from "../Components/UI/FlipCard";

function Landingpage() {
  const navigate = useNavigate();
  const allbookingsdeliveries = () => {
    navigate("/allbookingsdeliveries");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div>
      <div className="section-one">
        <div className="container">
          <div className="box-row">
            <div className="box-wrap">
              <div className="box-head">
                <span>President's message</span>
              </div>
              <div
                style={{
                  textAlign: "center",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src="/Images/ppdummy.png" alt="chairman" />
              </div>
              <div style={{ padding: "0 1rem 1rem 1rem", fontSize: "10pt" }}>
                <p className="tabbed-paragraph">
                  प्रिय निवासियों, हम सभी जानते हैं कि पानी जीवन का आधार है।
                  इसके बिना न तो प्रकृति जीवित रह सकती है, न ही ...
                </p>
              </div>
              <div style={{ textAlign: "right" }}>
                <button
                  className="readMoreButton"
                  onClick={() => {
                    navigate("/about-us");
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }}
                >
                  Read More ...
                </button>
              </div>
            </div>
            <div className="box-wrap">
              <div className="box-head">
                <span>Booking Reports</span>
              </div>
              <div style={{ paddingRight: "0rem" }}>
                <BookingReportList />
                <div style={{ textAlign: "right" }}>
                  <button
                    className="readMoreButton"
                    onClick={allbookingsdeliveries}
                  >
                    view all
                  </button>
                </div>
              </div>
            </div>

            <div className="box-wrap">
              <div className="box-head">
                <span>Delivery Reports</span>
              </div>
              <div style={{ paddingRight: "0rem" }}>
                {/* it is seved from database */}
                <DeliveryReportList />
                <div style={{ textAlign: "right" }}>
                  <button
                    className="readMoreButton"
                    onClick={allbookingsdeliveries}
                  >
                    view all
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="section-two">
        <div className="container">
          <div className="box-row">
            {/* <FlipCard
              linkTo="/"
              imageSrc="/Images/downloadsfile.jpg"
              imageAlt="Download"
              cardText="Download Circulars"
              minHeight="200px"
            />
            <FlipCard
              linkTo="/admission-procedure"
              imageSrc="/Images/AdmissionOpen.png"
              imageAlt="Admission Open for 2024-25"
              cardText="Admission Open 2024-25"
              minHeight="200px"
            />
            <FlipCard
              linkTo="/registeruser"
              imageSrc="/Images/onlineregistration.jpg"
              imageAlt="Online Registration"
              cardText="Online Registration"
              minHeight="200px"
            /> */}
            <div style={{ justifyContent: "flex" }}>
              <h4>
                जल प्रबंधन प्रणाली
                <br />
                (Jal Pravandhan System)
              </h4>
              <p className="drop-case">
                हमारे समाज में पानी की सुचारू उपलब्धता और वितरण के लिए एक आधुनिक{" "}
                <strong>जल प्रबंधन प्रणाली</strong> लागू की गई है। इस प्रणाली का
                उद्देश्य है कि प्रत्येक निवासी को समय पर और पारदर्शी तरीके से
                पानी की आपूर्ति मिल सके।
              </p>
              <h5 className="text-xl font-semibold mt-6 mb-2">
                मुख्य विशेषताएँ:
              </h5>
              <ol className="list-decimal list-inside space-y-2">
                <li>
                  <strong>ऑनलाइन टैंकर बुकिंग सुविधा:</strong> निवासी अपने
                  मोबाइल या कंप्यूटर से आसानी से{" "}
                  <strong>पानी का टैंकर बुक</strong> कर सकते हैं और
                  <strong> डिलीवरी रिपोर्ट </strong> देख सकते हैं । यह प्रक्रिया
                  पूरी तरह स्वचालित और पारदर्शी है।
                </li>
                <li>
                  <strong>डिलीवरी शेड्यूल की जानकारी:</strong> प्रत्येक बुकिंग
                  के बाद निवासियों को{" "}
                  <strong>टैंकर की निर्धारित डिलीवरी तिथि </strong> की जानकारी
                  ऑनलाइन पोर्टल के माध्यम से उपलब्ध रहती है। नागरिक किसी भी समय
                  बुकिंग और डिलीवरी रिपोर्ट ऑनलाइन जल पोर्टल पर देख सकते है।
                </li>
                <li>
                  <strong>मेंटेनेंस एजेंसी की जिम्मेदारी:</strong> जल आपूर्ति और
                  टैंकर संचालन का कार्य अधिकृत <strong>मेंटेनेंस एजेंसी</strong>{" "}
                  द्वारा किया जाता है। यह एजेंसी सुनिश्चित करती है कि टैंकर समय
                  पर पहुंचे और स्वच्छ पानी उपलब्ध कराया जाए।
                </li>
                <li>
                  <strong>पारदर्शिता और रिपोर्टिंग:</strong> सभी बुकिंग और
                  डिलीवरी विवरण ऑनलाइन रिकॉर्ड किए जाते हैं, जिससे{" "}
                  <strong>पानी के उपयोग और वितरण की निगरानी</strong> आसानी से की
                  जा सकती है।
                </li>
              </ol>
              <div>
                <h3>हमारा लक्ष्य:</h3>
                <blockquote
                  style={{
                    fontStyle: "italic",
                    textAlign: "center",
                    color: "#1e40af",
                    marginTop: "20px",
                  }}
                >
                  “हर घर तक स्वच्छ पानी — समय पर, सुरक्षित और पारदर्शी तरीके से
                  पहुंचाना।”
                </blockquote>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="section-two">
        <div className="title-focus">What We Offer</div>
        <div className="container">
          <div className="square-container">
            <div className="square-box">
              <div className="squarebox-text">Carrear counselling session</div>
            </div>
            <div className="square-box">
              <div className="squarebox-text">
                Legal and Correctional Learning Tools
              </div>
            </div>
            <div className="square-box">
              <div className="squarebox-text">Featured Speaker Sessions</div>
            </div>
            <div className="square-box">
              <div className="squarebox-text">Mock Court Proceedings</div>
            </div>
            <div className="square-box">
              <div className="squarebox-text">Legal Training Internship</div>
            </div>
            <div className="square-box">
              <div className="squarebox-text">Assured Placement Success</div>
            </div>
          </div>
        </div>
      </div> */}

      {/* <div className="section-one">
        <div className="title-focus">Affiliation & Accreditation</div>
        <div className="container">
          <div className="box-row">
            <div className="box-wrap" style={{ textAlign: "center" }}>
              <img
                src="/Images/CCSU-Logo.png"
                alt="CCS University"
                style={{ height: "200px", width: "auto" }}
              ></img>
            </div>
            <div className="box-wrap" style={{ textAlign: "center" }}>
              <img
                src="/Images/BCI-logo.png"
                alt="BCI"
                style={{ height: "200px", width: "auto" }}
              ></img>
            </div>

            <div className="box-wrap" style={{ textAlign: "center" }}>
              <img
                src="/Images/UPgovt-logo.png"
                alt="UP Govt"
                style={{ height: "200px", width: "auto" }}
              ></img>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}

export default Landingpage;
